import { TextInput, TextInputProps } from "@mantine/core";

interface CustomTextInputProps extends TextInputProps {
  ref?: any;
}

const CustomTextInput = (props: CustomTextInputProps) => {
  return (
    <TextInput
      labelProps={{
        size: "sm",
        mb: 2,
      }}
      mb={6}
      withAsterisk={props.required}
      {...props}
    />
  );
};

export default CustomTextInput;
